import { render } from "./Questionnaire.vue?vue&type=template&id=291491a2&scoped=true&ts=true"
import script from "./Questionnaire.vue?vue&type=script&lang=ts"
export * from "./Questionnaire.vue?vue&type=script&lang=ts"

import "./Questionnaire.vue?vue&type=style&index=0&id=291491a2&scoped=true&lang=stylus"

import exportComponent from "D:\\zhongzhi\\wuzangceping_sahngyeban\\health-WeChat-small-program-page\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-291491a2"]])

export default __exports__